export const filterByShouldShowDimensions = (shouldShowDimensions, file) => {
	return file?.tags?.withDimension === shouldShowDimensions || file?.tags?.withDimensions === shouldShowDimensions;
};
